<template>
    <div>
        <div class="devices-synchronization border-top pt-3 d-lg-flex justify-content-lg-between">
            <div class="w-100 px-3">
                <div class="typo-label mb-2">
                    Wersja systemu magazynowo - sprzedażowego
                </div>
                <span>{{ shopApiFirmware }}</span>
            </div>
            <div class="w-100 px-3">
                <div class="typo-label mb-2 d-flex align-items-end">
                    Ostatnia aktualizacja cen
                    <a-icon
                        icon="Info"
                        width="18px"
                        class="ml-1"
                        v-tooltip="'Dotyczy cen obowiązujących oraz cen Omnibus pobieranych z Twojego systemu zapleczowego na potrzeby uzupełniania danych w generatorze cenówek'"
                    />
                </div>
                <span>{{ shopApiPrice30LastUpdatedAt }}</span>
            </div>
        </div>
        <ui-data-table
            class="store-devices"
            headers-on-mobile
            table-name="tableName"
            mobile-breakpoint="md"
            :table-data="devicesTableData"
        />
    </div>
</template>

<script>
export default {
    name: 'StoreDevices',
    props: {
        location: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        devicesTableData() {
            const head = [
                'ID i nazwa kasy',
                'Producent i wersja oprogramowania',
                'Ostatnie połączenie'
            ]
            const body =
                this.location.devices?.map(item => {
                    return [
                        `${item.rad_id}<br/>${item.unique_name}`,
                        `${item.producer_name} ${item.firmware_version}`,
                        `${item.last_heartbeat_date}`
                    ]
                })
            return { head, body }
        },
        locationSynchronizationData() {
            return this.$store.getters.getLocationsSynchronization?.find(el => el.id === this.location.id)
        },
        shopApiFirmware() {
            return this.locationSynchronizationData?.shopApiFirmware || '-'
        },
        shopApiPrice30LastUpdatedAt() {
            return this.locationSynchronizationData?.shopApiPrice30LastUpdatedAt || '-'
        }
    },
    methods: {
        getShopAddress(address) {
            const {
                street,
                postal_code: postalCode,
                city,
                building,
                local
            } = address
            return `${street} ${building}${
                local ? '/' + local : ''
            }, ${postalCode} ${city}`
        }
    }
}
</script>
